import { useMemo } from "react";

// Build a month grid with due-date markers
function monthGrid(year, month, dueDates) {
  const first = new Date(year, month, 1);
  const startDow = first.getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const prevDays = new Date(year, month, 0).getDate();
  const cells = [];
  for (let i = 0; i < startDow; i++) {
    cells.push({ n: prevDays - startDow + 1 + i, muted: true });
  }
  const today = new Date();
  const dueSet = new Set(dueDates.map((d) => d));
  for (let d = 1; d <= daysInMonth; d++) {
    const iso = new Date(year, month, d).toISOString().slice(0, 10);
    cells.push({
      n: d,
      due: dueSet.has(iso),
      today:
        today.getFullYear() === year &&
        today.getMonth() === month &&
        today.getDate() === d,
    });
  }
  while (cells.length % 7 !== 0) cells.push({ n: cells.length - daysInMonth - startDow + 1, muted: true });
  return cells;
}

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const DOW = ["S","M","T","W","T","F","S"];

export default function PaymentCalendar({ payments = [], testid = "payment-calendar" }) {
  const now = new Date();
  const [year, month] = useMemo(() => [now.getFullYear(), now.getMonth()], []);
  const cells = useMemo(
    () => monthGrid(year, month, payments.filter((p) => p.status !== "paid").map((p) => p.due_date?.slice(0, 10))),
    [year, month, payments]
  );
  return (
    <div className="panel p-6" data-testid={testid}>
      <div className="flex items-baseline justify-between mb-4">
        <div>
          <p className="label">Payment calendar</p>
          <h3 className="title-xl text-3xl mt-1">{MONTHS[month]} {year}</h3>
        </div>
        <p className="label">{payments.filter((p) => p.status !== "paid").length} upcoming</p>
      </div>
      <div className="grid grid-cols-7 gap-1 mb-1">
        {DOW.map((d, i) => (
          <div key={i} className="text-center label py-1">{d}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((c, i) => (
          <div
            key={i}
            className={`cal-cell ${c.muted ? "cal-cell--muted" : ""} ${c.today ? "cal-cell--today" : ""} ${c.due ? "cal-cell--due" : ""}`}
          >
            {c.n}
          </div>
        ))}
      </div>
    </div>
  );
}
